import { jwtDecode } from "jwt-decode";
import type { User } from "./types";

/**
 * The user described by an Auth0 token, or null when it has no `sub`. The id
 * token carries the standard `email` claim; the access token carries it as
 * `urn:visioni:email` (added by Vision Auth), so either token yields the email.
 */
export function parseJWT(token: string): User | null {
  try {
    const payload = jwtDecode<{
      sub?: string;
      email?: string;
      "urn:visioni:email"?: string;
      name?: string;
      picture?: string;
    }>(token);

    if (!payload.sub) return null;

    return {
      id: payload.sub,
      email: payload.email || payload["urn:visioni:email"] || "",
      name: payload.name,
      picture: payload.picture,
    };
  } catch {
    return null;
  }
}
